import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { DuplicatesPage } from "@/features/duplicates/DuplicatesPage";

const search = z.object({
  pair: z.string().optional(),
});

export const Route = createFileRoute("/_app/clients/duplicates")({
  validateSearch: search,
  component: () => <DuplicatesPage search={Route.useSearch()} />,
});
